// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Help-module_link_button_eZZFe {
  font-size: 24px;
  margin-left: 0;
  padding-left: 0;
}

.Help-module_email_link_button__SOg9 {
  margin-left: 50px;
}

.Help-module_help_card_WkO58 {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.Help-module_help_box_R57bG {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-left: 4px;
}

.Help-module_more_help_header_hiSyZ {
  color: var(--uu-text);
}

.Help-module_help_info_text_syLHY {
  display: flex;
  font-size: large;
  color: var(--uu-text-lighter);
}

.Help-module_help_info_icon_NgPBX {
  margin-right: 8px;
}

.Help-module_questions_box_sdV2G {
  display: flex;
  flex-direction: column;
}
`, "",{"version":3,"sources":["webpack://./src/client/pages/Help.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB","sourcesContent":[".link_button {\n  font-size: 24px;\n  margin-left: 0;\n  padding-left: 0;\n}\n\n.email_link_button {\n  margin-left: 50px;\n}\n\n.help_card {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.help_box {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  margin-left: 4px;\n}\n\n.more_help_header {\n  color: var(--uu-text);\n}\n\n.help_info_text {\n  display: flex;\n  font-size: large;\n  color: var(--uu-text-lighter);\n}\n\n.help_info_icon {\n  margin-right: 8px;\n}\n\n.questions_box {\n  display: flex;\n  flex-direction: column;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link_button": `Help-module_link_button_eZZFe`,
	"email_link_button": `Help-module_email_link_button__SOg9`,
	"help_card": `Help-module_help_card_WkO58`,
	"help_box": `Help-module_help_box_R57bG`,
	"more_help_header": `Help-module_more_help_header_hiSyZ`,
	"help_info_text": `Help-module_help_info_text_syLHY`,
	"help_info_icon": `Help-module_help_info_icon_NgPBX`,
	"questions_box": `Help-module_questions_box_sdV2G`
};
export default ___CSS_LOADER_EXPORT___;
